module.exports = __webpack_public_path__ + "images/marketing_site/iphone_app/button_sign_me_up.png";